import { AppBar, Container, Stack } from "@mui/material";
import { Outlet, useLocation, useParams } from "react-router-dom";
import BottomDashboardNavBar from "src/components/NavBars/BottomDashboardNavBar";
import DashboardNavBar from "src/components/NavBars/DashboardNavBar";
import { MatchParam } from "src/constants/matches";
import PatientSubscriptionsProvider from "src/context/PatientSubscriptionsProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const DashboardLayout = () => {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  //check if the path includes the message thread id
  const { threadId } = useParams<MatchParam<"THREAD_ID">>();

  return (
    <PatientSubscriptionsProvider>
      <Stack height={"100%"}>
        {threadId && pathname.includes(threadId) && isMobile ? (
          <Outlet />
        ) : (
          <>
            <AppBar
              position="fixed"
              sx={{
                width: "100%",
                boxShadow: "0px 3px 13px 0px rgba(0, 0, 0, 0.05)",
                color: "#000000",
                backgroundColor: "#ffffff",
              }}
            >
              <DashboardNavBar />
            </AppBar>
            <Container
              disableGutters
              maxWidth="lg"
              sx={{
                p: 2,
                flexGrow: 1,
                mt: 10,
                mb: isMobile ? 10 : 0,
              }}
            >
              <Outlet />
            </Container>
          </>
        )}

        {isMobile && !pathname.includes(threadId!) ? (
          <AppBar
            position="fixed"
            sx={{
              top: "auto",
              bottom: 0,
              width: "100%",
              color: "#000000",
              backgroundColor: "#ffffff",
              boxShadow: "0px -3px 8px 0px rgba(0, 0, 0, 0.06)",
            }}
          >
            <BottomDashboardNavBar />
          </AppBar>
        ) : null}
      </Stack>
    </PatientSubscriptionsProvider>
  );
};

export default DashboardLayout;
